import { ButtonProps } from '@mui/material';
import { useConnection, useWalletConnectModal } from 'modules/auth';
import { Button } from 'modules/common/components/Button';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';

interface ConnectWalletBtnProps extends ButtonProps {
  isShortText?: boolean;
}

export function ConnectWalletBtn({
  isShortText = true,
  ...props
}: ConnectWalletBtnProps) {
  const { keys, t } = useTranslation(translation);
  const { onOpen } = useWalletConnectModal();
  const { isLoading } = useConnection();

  return (
    <Button
      variant="contained"
      onClick={onOpen}
      isLoading={isLoading}
      {...props}
    >
      {t(isShortText ? keys.connect : keys.connectWallet)}
    </Button>
  );
}
